import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReallocationV2Store } from '../../state/reallocation-v2.store';

/** Step 2 — mark which remaining (Custom Holdings) positions are Do Not Trade. */
@Component({
  selector: 'app-rav2-do-not-trade-step',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './do-not-trade-step.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoNotTradeStepComponent {
  readonly store = inject(ReallocationV2Store);

  onDntToggle(ticker: string, event: Event): void {
    this.store.toggleDnt(ticker, (event.target as HTMLInputElement).checked);
  }

  onDntToggleAll(event: Event): void {
    this.store.toggleDntAll((event.target as HTMLInputElement).checked);
  }

  get dntCount(): number {
    return this.store.markedDoNotTrade().length;
  }

  /** The marked tickers, for the advisor to read back before attesting. */
  get markedTickers(): string {
    return this.store.markedDoNotTrade().map((p) => p.ticker).join(', ');
  }

  onConfirm(event: Event): void {
    this.store.setDntConfirmed((event.target as HTMLInputElement).checked);
  }
}
